import { CS } from "../../../../../base/utils/styler";

export const baseStyle: CS = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 8fr',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '10px',
    marginBottom: '30px'
}

export const titleStyle: CS = {
    paddingTop: '15px',
    fontSize: '16px',
}

export const spacerStyle: CS = {}

export const wrapStyle: CS = {
    position: 'relative',
}

export const fieldStyle: CS = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '6px',
    padding: '8px',
    border: '1px solid #d9d9d9',
    borderRadius: '10px',
    minHeight: '42px',
    cursor: 'text',
    direction: 'rtl',
}

export const chipStyle: CS = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#eef3ff',
    color: '#1a3aa8',
    border: '1px solid #c6d2f5',
    borderRadius: '999px',
    padding: '4px 10px',
    fontSize: '14px',
}

export const chipRemoveStyle: CS = {
    cursor: 'pointer',
    fontWeight: 'bold',
    color: '#6b7aa3',
    fontSize: '16px',
    lineHeight: '1',
    '&:hover': {
        color: '#1a3aa8',
    },
}

export const inputStyle: CS = {
    flex: '1',
    minWidth: '120px',
    border: 'none',
    outline: 'none',
    padding: '6px',
    fontSize: '15px',
    textAlign: 'right',
    direction: 'rtl',
    background: 'transparent',
}

export const dropdownStyle: CS = {
    position: 'absolute',
    top: '100%',
    right: '0',
    left: '0',
    marginTop: '4px',
    backgroundColor: '#fff',
    border: '1px solid #d9d9d9',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    maxHeight: '220px',
    overflowY: 'auto',
    zIndex: '10',
    direction: 'rtl',
    display: 'none',
}

export const suggestionStyle: CS = {
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: '15px',
    '&:hover': {
        backgroundColor: '#f4f7ff',
    },
}

export const suggestionActiveStyle: CS = {
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: '15px',
    backgroundColor: '#eef3ff',
    color: '#1a3aa8',
}
